module.exports = __webpack_public_path__ + "static/cartorio-azevedo-bastos-f33f0223ebf778dd1aa1926d7c779f9b.png";